import { Directive, HostListener, Input } from '@angular/core'
import { createFrom, EventService, Product, RoutingService } from '@spartacus/core'
import { ProductClickEvent } from '../events/product-click.event'
import { map, take } from 'rxjs/operators'

@Directive({
  selector: '[mbProductClick]'
})
export class MbProductClickDirective {

  #product: Product | undefined

  constructor (protected eventService: EventService,
              protected routingService: RoutingService) {
  }

  @Input()
  set mbProductClick (product: Product) {
    if (product) {
      this.#product = product
    }
  }

  @HostListener('click', ['$event'])
  onClick (event: Event) {
    if (this.#product) {
      this.routingService.getRouterState().pipe(
        take(1),
        map(s => s.state),
        map(navigation => createFrom(ProductClickEvent, {
          navigation,
          product: this.#product,
          event
        }))
      ).subscribe(ev => this.eventService.dispatch(ev))
    }
  }
}
